import { Fragment, useState } from 'react';
import AssociateDialog from './AssociateDialog';
import GroupingsDialog from './GroupingsDialog';

export default function Grouping({ associateOpen, groupingsOpen, setGroupingsOpen, featureGroupIds, setFeatureGroupIds,
  featureGroupItems, setFeatureGroupItems, associateHandleClose, associatedCount, setAssociatedCount, isLoading, treatments, activities, currentFeature,
  setCurrentFeature, featureGroups, actualTreatments, actualActivities, setIsLoading, isFromList, isCurrentTreatment, isCurrentActual }) {
  const [toggleRefresh, setToggleRefresh] = useState(false);
  const [isChangesMade, setIsChangesMade] = useState(false);
  const [snackbarWarningOpen, setSnackbarWarningOpen] = useState(false);

  const displayGroupingsClose = (isChanged) => {
    if(isChanged){
      setSnackbarWarningOpen(true);
    } else {
      setGroupingsOpen(false);
      setToggleRefresh(!toggleRefresh);
    }
  }

  return (
    <Fragment>
      <AssociateDialog
        associateHandleClose={associateHandleClose}
        associateOpen={associateOpen}
        associatedCount={associatedCount}
        setAssociatedCount={setAssociatedCount}
        isLoading={isLoading}
        treatments={treatments}
        activities={activities}
        currentFeature={currentFeature}
        setCurrentFeature={setCurrentFeature}
        actualTreatments={actualTreatments}
        actualActivities={actualActivities} 
        setIsLoading={setIsLoading} 
        isFromList={isFromList} 
        />
      <GroupingsDialog setFeatureGroupItems={setFeatureGroupItems} setFeatureGroupIds={setFeatureGroupIds} featureGroupIds={featureGroupIds}
         featureGroupItems={featureGroupItems} displayGroupingsClose={displayGroupingsClose} groupingsOpen={groupingsOpen} 
         setAssociatedCount={setAssociatedCount} isChangesMade={isChangesMade} setIsChangesMade={setIsChangesMade} snackbarWarningOpen={snackbarWarningOpen} setSnackbarWarningOpen={setSnackbarWarningOpen} 
         treatments={treatments} activities={activities} currentFeature={currentFeature} setCurrentFeature={setCurrentFeature} featureGroups={featureGroups} actualTreatments={actualTreatments}
         actualActivities={actualActivities}
      />
    </Fragment>
  )
}